const posts = [
  {
    id: "mou-signing",
    title: "MOU Signing with Kaduna Govt & StarAgri",
    summary: "Kaduna State signs a multi-party MOU with StarAgri and The Alternative Bank to expand agro-financing through the Prime Anchor Model.",
    image: "https://via.placeholder.com/600x300?text=MOU+Signing",
    content: `Full post content goes here. Could include images, text, or even embedded videos.`,
  },
  {
    id: "fertilizer-distribution",
    title: "Fertilizer Distribution Begins",
    summary: "Supervised rollout of subsidized fertilizer to cooperative clusters begins in Zone 3.",
    image: "https://via.placeholder.com/600x300?text=Fertilizer+Distribution",
    content: `Full report, logistics, and outcomes will be updated.`,
  },
  {
    id: "nags-ap-launch",
    title: "Adoption of NAGS-AP Tool",
    summary: "Agro-pockets introduced as new channel for digitally verifiable farmer support and credit access.",
    image: "https://via.placeholder.com/600x300?text=NAGS-AP+Launch",
    content: `Details about the Agro-Pocket adoption process.`,
  },
];

export default posts;